import {
    NinchatActionType,
    NinchatPartChannelAction,
} from 'api/types/actions'
import ninchatClient, {
    NinchatActionParams,
} from 'api/NinchatClient'
import {NinchatChannelPartedEvent} from 'api/types/events'
import {NinchatProperties} from 'api/types'
import {RootState} from 'store'
import {Route} from 'navigation/types'
import {createAsyncThunk} from '@reduxjs/toolkit'
import {jitsiHangup} from 'actions/jitsi'

import {replace} from 'navigation/actions'
import router from 'navigation/router'
import {startAppListening} from 'middlewares/listener'

const actionTypePrefix = 'NINCHAT/action'

export const partChannel = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatPartChannelAction}`,
    async (arg: NinchatActionParams<NinchatPartChannelAction>, {
        rejectWithValue, getState, dispatch,
    }) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatPartChannelAction

        const {
            activeVideoChannelId, isActive,
        // eslint-disable-next-line no-extra-parens
        } = (getState() as RootState).jitsi

        // if there is active jitsi meeting and im leaving a channel
        if (isActive && activeVideoChannelId === params.channel_id) {
            await dispatch(jitsiHangup())
        }

        try {
            return await ninchatClient.send(params) as NinchatChannelPartedEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)

startAppListening({
    actionCreator: partChannel.pending,
    effect: (action, listenerApi) => {
        listenerApi.cancelActiveListeners()

        const {channel_id} = action.meta.arg

        const {
            position,
            routes,
        } = listenerApi.getState().navigation
        const {
            user_channels, user_queues,
        } = listenerApi.getState().ninchat

        const route = routes[position]
        const {queue_id} = user_channels[channel_id].channel_attrs
        const queue = user_queues ? user_queues[queue_id || ''] : undefined
        const group_id = queue?.queue_attrs?.group_id

        const isAudience = (cid: NinchatProperties.ChannelID) => !!user_channels[cid]?.channel_attrs.audience_id

        if (router.isRoute<'Channel'>('Channel', route) && route.params.channel_id === channel_id) {
            if (isAudience(channel_id)) {
                const previousAudienceRoute = routes
                    .slice(0, position)
                    .reverse()
                    .find((r) => router.isRoute<'Channel'>('Channel', r) && isAudience(r.params.channel_id) && r.params.channel_id !== channel_id)

                listenerApi.dispatch(replace(previousAudienceRoute ?? {
                    name: 'Queue',
                    params: {queue_id: group_id || queue_id},
                } as Route))
            } else {
                listenerApi.dispatch(replace({name: 'Home'}))
            }
        }
    },
})
